import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/sections/Navbar';
import { Footer } from './components/sections/Footer';
import { Hero } from './components/sections/Hero';
import { ProblemSection } from './components/sections/ProblemSection';
import { FilterDemoSection } from './components/sections/FilterDemoSection';
import { ProductSection } from './components/sections/ProductSection';
import { HowItWorksSection } from './components/sections/HowItWorksSection';
import { AppSection } from './components/sections/AppSection';
import { TestimonialSection } from './components/sections/TestimonialSection';
import { FAQSection } from './components/sections/FAQSection';
import { CTASection } from './components/sections/CTASection';
import { ShopPage } from './components/sections/ShopPage';
import { SolutionPage } from './components/sections/SolutionPage';
import { AboutPage } from './components/sections/AboutPage';
import { CartPage } from './components/sections/CartPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { useMousePosition } from './hooks/useMousePosition';
import { theme } from './utils/theme';

const Home = ({ systemActive, setSystemActive }) => {
  return (
    <>
      <Hero systemActive={systemActive} />
      <ProblemSection />
      <FilterDemoSection systemActive={systemActive} onToggleSystem={() => setSystemActive(!systemActive)} />
      <ProductSection systemActive={systemActive} />
      <HowItWorksSection />
      <AppSection systemActive={systemActive} />
      <TestimonialSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

const App = () => {
  const [systemActive, setSystemActive] = useState(true);
  const mousePosition = useMousePosition();
  const glowColor = systemActive ? 'rgba(231, 165, 95, 0.15)' : 'rgba(157, 204, 195, 0.08)';

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-black text-white relative">
        <div 
          className="fixed inset-0 z-0 opacity-[0.06] pointer-events-none" 
          style={{ 
            backgroundImage: `linear-gradient(${theme.colors.text} 1px, transparent 1px), linear-gradient(90deg, ${theme.colors.text} 1px, transparent 1px)`, 
            backgroundSize: '50px 50px',
            maskImage: 'radial-gradient(circle at center, black, transparent 80%)'
          }}
        />
        <div 
          className="pointer-events-none fixed inset-0 z-0 transition-opacity duration-700"
          style={{
            background: `radial-gradient(800px circle at ${mousePosition.x}px ${mousePosition.y}px, ${glowColor}, transparent 40%)`,
          }}
        />
        <div className="relative z-10 w-full">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home systemActive={systemActive} setSystemActive={setSystemActive} />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/solution" element={<SolutionPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/cart" element={<CartPage />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </LanguageProvider>
  );
};

export default App;